import { SortDirections, wafflesKeyColumnName } from "@app/shared/waffles";
import { PatternOfCareProviderModel, PatternOfCareProvidersTableModel } from "./interfaces";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import Roles from "@app/user/roles";
import { UserInfo } from "@app/user";

export const buildTableData = (providers: PatternOfCareProviderModel[], user: UserInfo): PatternOfCareProvidersTableModel[] => {
  return providers.map((provider) => {
    /* eslint-disable sort-keys */
    return {
      [wafflesKeyColumnName]: provider.providerId.toString(),
      name: (
        // key is used in customSort
        <span key={provider.displayName}>
          {provider.displayName} <br />
          {provider.npi ? <><span className="pattern-of-care__provider-info">NPI: {provider.npi}</span><br /></> : null}
          {provider.tin && user.roles.includes(Roles.TIN_VIEWER) && <>TIN: {provider.tin}<br /></>}
          {provider.organizationName ? <><span className="pattern-of-care__provider-info">{provider.organizationName}</span><br /></> : null}
          {!provider.npi ? <><br /><TooltipWrapper text="NPI is required to append pattern of care providers" position="right"><QesIcon iconName={QesIcons.FontAwesome.InfoCircle} classNames="align-baseline" description="Info Indicator" /></TooltipWrapper></> : null}
        </span>
      ),
      specialty: provider.specialty,
      address: (
        <span key={provider.address}>
          {provider.address}<br />
          {!!provider.address2 ? <>{provider.address2}<br /></> : null}
          {provider.city}, {provider.state} {provider.zip}<br />
          {provider.phone ? <><TooltipWrapper text="Phone" position="bottom"><QesIcon iconName={QesIcons.FontAwesome.Phone} classNames="align-baseline" description="Phone Number" /></TooltipWrapper> {provider.phone}<br /></> : null}
          {provider.fax ? <><TooltipWrapper text="Fax" position="bottom"><QesIcon iconName={QesIcons.FontAwesome.Fax} classNames="align-baseline" description="Fax Number" /></TooltipWrapper> {provider.fax}</> : null}
        </span>
      ),
      checkBoxIsDisabled: !provider.npi
    };
    /* eslint-enable */
  })
}

export const customSort = (rows: PatternOfCareProvidersTableModel[], column: keyof PatternOfCareProvidersTableModel, direction: SortDirections): PatternOfCareProvidersTableModel[] => {
  const multiplier = direction === SortDirections.Asc ? 1 : -1;
  switch (column) {
    case "address":
    case "name":
      return rows.sort((a, b) => (a[column].key > b[column].key ? 1 : -1) * multiplier);
    case "specialty":
      return rows.sort((a, b) => (a[column] > b[column] ? 1 : -1) * multiplier);
  }
}